import { Col, Modal, ModalBody, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button';
import { PENSION_ROUTE } from '../../../routes/types';

export type customOnSaveModal = React.PropsWithoutRef<{
  showModal: boolean;
  handleClose: () => void;
}>;

const OnSaveModal = ({
  showModal,
  handleClose,
  ...props
}: customOnSaveModal) => {
  const navigate = useNavigate();

  return (
    <Modal show={showModal} onHide={handleClose} {...props} size={'xl'}>
      <ModalBody>
        <Row className="m-0">
          <Col className={'col-12 text-center mt-12'}>
            <h4>Save Estimate</h4>
          </Col>
          <Col className={'col-12 text-center mt-12'}>
            <img
              src={`${process.env.PUBLIC_URL}/${'save-estimate.png'}`}
              alt={`save-estimate`}
            />
          </Col>

          <Col className={'col-12 p-0 mt-12 fw-light lh-xs text-center'}>
            <span>
              Your estimate has been saved successfully. All of your saved
              estimates can be accessed in the Saved Estimates section.
            </span>
          </Col>
        </Row>
      </ModalBody>
      <Modal.Footer className={'pt-0 mt-12'}>
        <Button variant="primary-outline" onMouseDown={handleClose}>
          Back to Results
        </Button>
        <Button
          variant="primary"
          className="order-1 order-lg-2 ms-4"
          onClick={() => {
            navigate(`${PENSION_ROUTE.replace(':tab', 'saved')}`);
            handleClose();
          }}
        >
          Go to Saved Estimates
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OnSaveModal;
